import React, { Component } from 'react'
import { toast } from 'react-toastify'
import { reduce, size } from 'libraries/lodash'
import debug from 'front-end-core/core/debug'
import notificationToast from 'helpers/notificationToast'
import { reEncryptComments } from 'services/CommentsService'
import ClockIcon from '@material-ui/icons/AccessTime'
import ErrorIcon from '@material-ui/icons/Error'
import CheckIcon from '@material-ui/icons/CheckCircle'
import TealToolTip from 'components/TealToolTip'
import Icon from 'components/shared/Icon'
import EncryptionUrlBadge from './EncryptionUrlBadge'

class EncryptionUrl extends Component {
  state = {
    disableButtons: false
  }

  handleMigrate = () => {
    this.setState({ disableButtons: true })
    const enableButtons = () => this.setState({ disableButtons: false })
    const related = this.commentsRelated
    const notificationId = notificationToast(<ClockIcon />, toast.TYPE.INFO, `Migrating comment 1 of ${related.length}`, '', false)
    reEncryptComments(related)
      .subscribe({
        next ({ index, total, error, errors }) {
          const message = errors ? `Migrating comment ${index} of ${total}. ${errors} error${errors !== 1 ? 's' : ''}` : `Migrating comment ${index} of ${total}`
          toast.update(notificationId, { type: errors ? toast.TYPE.WARNING : toast.TYPE.INFO, message })

          if (error) {
            notificationToast(<ErrorIcon />, toast.TYPE.ERROR, 'Error', 'bg-indian-red white', 15000)
          }
        },
        error (err) {
          debug.warn(err)
          toast.dismiss(notificationId)
          notificationToast(<ErrorIcon />, toast.TYPE.ERROR, 'Migration failed', 'bg-indian-red white', 10000)
          enableButtons()
        },
        complete () {
          toast.dismiss(notificationId)
          notificationToast(<CheckIcon />, toast.TYPE.SUCCESS, 'Migration completed')
          enableButtons()
        }
      })
  }

  get commentsTotal () {
    return size(this.props.comments)
  }

  get commentsRelated () {
    return reduce(this.props.comments, (agg, c) => c.keyUrl === this.props.url ? [...agg, c.id] : agg, [])
  }

  get commentsPendingDecryption () {
    return reduce(this.props.comments, (agg, c) => c.decryptionStatus === 'pending' ? agg + 1 : agg, 0)
  }

  renderButton () {
    const tot = this.commentsTotal
    const pen = this.commentsPendingDecryption
    const rel = this.commentsRelated
    const dis = this.state.disableButtons
    const { isPrimary: pri } = this.props

    if (!!tot && !pen && !pri && !!rel.length) {
      return (
        <button
          onClick={this.handleMigrate}
          disabled={dis}
          className='bg-void-grey black pv3 ph5 ba b--transparent br2 normal f6 lh-copy-variant hover-o-90'
        >
          Migrate {rel.length}
        </button>
      )
    }

    return null
  }

  render () {
    const { url, isPrimary, isValid, even } = this.props

    return (
      <div
        className='flex items-center justify-between pv6 ph5'
        {...(even && { style: { backgroundColor: 'white' } })}
      >
        <div className='flex items-center'>
          <EncryptionUrlBadge count={this.commentsRelated.length} isPrimary={isPrimary} />
          <span className='mh2'>
            {url}
          </span>
          {isValid
            ? (
              <TealToolTip arrow title='Encryption key loaded'>
                <span>
                  <Icon name='icon-check' className='vm mb1' />
                </span>
              </TealToolTip>
              )
            : (
              <TealToolTip arrow title='Encryption key error'>
                <span>
                  <Icon name='icon-alert' className='vm mb1 w7' />
                </span>
              </TealToolTip>
              )}
        </div>
        {this.renderButton()}
      </div>
    )
  }
}

export default EncryptionUrl
